import { ReduxSimpleActionInterface } from '@ecommerce/nest-ssr/dist/common';
import { ProductBoxWideProps } from 'modules/shared/components/product/product-box-wide/product-box-wide.props';
import { ProductBoxNarrowProps } from 'modules/shared/components/product/product-box-narrow/product-box-narrow.props';
import { CategoryProductsInterface } from 'modules/categories/views/pages/category-regular/category-regular-page.props';

export enum ProductsActions {
    ADD_PRODUCT = 'ADD_PRODUCT',
    ADD_PRODUCTS = 'ADD_PRODUCTS'
}

export const products = [
    (
        state: CategoryProductsInterface<ProductBoxWideProps | ProductBoxNarrowProps>,
        action: ReduxSimpleActionInterface<ProductsActions.ADD_PRODUCT, { payload: { product: ProductBoxWideProps | ProductBoxNarrowProps; }; }> |
            ReduxSimpleActionInterface<ProductsActions.ADD_PRODUCTS, { payload: { products: ProductBoxWideProps[] | ProductBoxNarrowProps[]; }; }>
    ): CategoryProductsInterface<ProductBoxWideProps | ProductBoxNarrowProps> => {
        switch (action.type) {
            case ProductsActions.ADD_PRODUCT:
                return { ...state, items: [action.payload.product, ...state.items.filter(item => item.id !== action.payload.product.id)] };
            case ProductsActions.ADD_PRODUCTS: {
                const products = action.payload.products;

                if (!products?.length) {
                    return state;
                }

                const productIds = products.map(product => product.id);

                return { ...state, items: [...products, ...state.items.filter(item => !productIds.includes(item.id))] };
            }
            default:
                return state;
        }
    }
];
